import React from 'react';
import NotFoundBox from './components/NotFoundBox';

export default function NotFound() {
  return <NotFoundBox />;
}
